import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track", "prev", "next", "counter"]
  static values  = { loop: { type: Boolean, default: false } }

  connect() {
    this.trackTarget.addEventListener("scroll", () => this.update(), { passive: true })
    this.update()
  }

  prev() {
    this.trackTarget.scrollLeft -= this.trackTarget.clientWidth
  }

  next() {
    const { scrollLeft, scrollWidth, clientWidth } = this.trackTarget
    const atEnd = scrollLeft + clientWidth >= scrollWidth - 1

    if (atEnd && this.loopValue) {
      this.trackTarget.scrollLeft = 0
    } else {
      this.trackTarget.scrollLeft += clientWidth
    }
  }

  update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.trackTarget
    const total = Math.round(scrollWidth / clientWidth)
    const current = Math.round(scrollLeft / clientWidth) + 1

    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${current} / ${total}`
    }

    if (this.hasPrevTarget) {
      this.prevTarget.classList.toggle("d-none", current <= 1)
    }

    if (this.hasNextTarget && !this.loopValue) {
      this.nextTarget.classList.toggle("d-none", current >= total)
    }
  }
}
